import IconButton from '../IconButton/IconButton';
import type { ReactNode, RefObject } from 'react';
import './Dialog.css';

interface DialogProps {
  body?: ReactNode;
  footer?: ReactNode;
  ref?: RefObject<HTMLDialogElement | null>;
  title: string;
  variant?: 'default' | 'white';
  onClose: () => void;
}

export default function Dialog({
  ref,
  title,
  variant,
  onClose,
  body,
  footer
}: DialogProps) {
  return (
    <dialog
      ref={ref}
      className={['Dialog', variant === 'white' ? 'Dialog--white' : '']
        .filter(Boolean)
        .join(' ')}
    >
      <div className="Dialog-header">
        <h3 className="Dialog-title">{title}</h3>
        <IconButton
          className="Dialog-closeButton"
          icon="xmark"
          label="Close"
          size={28}
          onClick={onClose}
        />
      </div>
      <div className="Dialog-body">{body}</div>
      <div className="Dialog-footer">{footer}</div>
    </dialog>
  );
}
